import React, { useEffect, useState } from "react"
import styles from "./transactions.module.css"
import { useParams } from 'react-router-dom'
import Loading from "../../layouts/Loading"
import api from "../../../services/api"
import StatusPaid from "./StatusPaid"
import Logo from "../../../logo.svg"
import { TbCreditCard, TbExternalLink, TbReceiptTax } from "react-icons/tb"
import { MdStar } from "react-icons/md"

const PaymentView = () => {
    const [loading, setLoading] = useState(true)
    const [processing, setProcessing] = useState(false)
    const [paid, setPaid] = useState(false)
    const [invalid, setInvalid] = useState(false)
    const [payment, setPayment] = useState(null)
    const [cards, setCards] = useState([])
    const [selectedCard, setSelectedCard] = useState("")
    const [cardsAvailable, setCardsAvailable] = useState(false)
    const [message, setMessage] = useState("")
    const [statusMessage, setStatusMessage] = useState("")

    const { transaction_id, charge_id } = useParams()

    useEffect(() => {
        if (transaction_id && charge_id) {
            getLinkPayment()
        }
    }, [transaction_id, charge_id])

    const getLinkPayment = async () => {
        try {
            const response = await api.get(`/accounts/transactions/${transaction_id}/${charge_id}/payment`)
            const data = response?.data?.data || {}
            if (data?.paid) {
                setPaid(true)
            } else if (data?.invalid) {
                setStatusMessage("A cobrança não está mais disponível para pagamento.")
                setInvalid(true)
            } else {
                setPayment(data)
                if (data?.can_use_saved_cards && data?.account_id) {
                    await getSavedCards(data.account_id)
                }
            }
        } catch (err) {
            setStatusMessage(err?.response?.data?.message)
            setInvalid(true)
        } finally {
            setLoading(false)
        }
    }

    const getSavedCards = async (accountId) => {
        const token = localStorage.getItem("@oktto:token")
        if (!token) {
            return
        }

        try {
            const response = await api.get("/transactions/credit-cards", {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "x-api-key": accountId,
                }
            })
            const listCards = response?.data?.data || []
            setCards(listCards)
            setCardsAvailable(true)
            const defaultCard = listCards.find(card => card.is_default) || listCards[0]
            setSelectedCard(defaultCard?._id || "")
        } catch (err) {
            setCardsAvailable(false)
        }
    }

    const openStripeLink = () => {
        if (payment?.link) {
            window.open(payment.link, "_blank", "noopener,noreferrer")
        }
    }

    const payWithSavedCard = async () => {
        if (!selectedCard || !payment?.account_id) {
            return
        }

        setProcessing(true)
        setMessage("")
        try {
            const token = localStorage.getItem("@oktto:token")
            const response = await api.post(`/accounts/transactions/${transaction_id}/${charge_id}/payment/cards/${selectedCard}`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "x-api-key": payment.account_id,
                }
            })
            setPaid(true)
            setPayment(null)
            setMessage(response?.data?.message)
        } catch (err) {
            setMessage(err?.response?.data?.message || "Não foi possível pagar com o cartão selecionado.")
        } finally {
            setProcessing(false)
        }
    }

    return (
        <div className={styles.container}>
            {(paid || invalid) && <StatusPaid paid={paid} invalid={invalid} message={statusMessage} onRetry={invalid ? getLinkPayment : null} />}
            {!paid && !invalid && payment &&
                <div className={styles.paymentPanel}>
                    <div className={styles.header}>
                        <img src={Logo} alt="Oktto" />
                        <div>
                            <span>Pagamento seguro</span>
                            <strong>Cobrança Oktto</strong>
                        </div>
                    </div>
                    <div className={styles.summary}>
                        <div className={styles.summaryIcon}>
                            <TbReceiptTax />
                        </div>
                        <div>
                            <span>Valor</span>
                            <strong>{payment.value || "-"}</strong>
                        </div>
                        <div>
                            <span>Vencimento</span>
                            <strong>{payment.due_date || "-"}</strong>
                        </div>
                    </div>
                    {cardsAvailable && cards.length > 0 &&
                        <div className={styles.savedCards}>
                            <div className={styles.sectionTitle}>
                                <span>Cartões salvos</span>
                                <small>Use um cartão já cadastrado nesta conta.</small>
                            </div>
                            {cards.map(card => (
                                <button
                                    className={`${styles.cardOption} ${selectedCard === card._id ? styles.active : ""}`}
                                    key={card._id}
                                    type="button"
                                    onClick={() => setSelectedCard(card._id)}
                                >
                                    <TbCreditCard />
                                    <div>
                                        <strong>{card.display_name || card.name}</strong>
                                        <span>Expira em {card.exp_month || "--"}/{card.exp_year || "----"}</span>
                                    </div>
                                    {card.is_default && <small><MdStar />Padrão</small>}
                                </button>
                            ))}
                            <button className={styles.primaryAction} type="button" onClick={payWithSavedCard} disabled={!selectedCard || processing}>
                                <TbCreditCard />Pagar com cartão selecionado
                            </button>
                        </div>
                    }
                    {message && <div className={styles.notice}>{message}</div>}
                    {cardsAvailable && cards.length > 0 && <div className={styles.divider}><span>ou</span></div>}
                    <button className={styles.secondaryAction} type="button" onClick={openStripeLink}>
                        <TbExternalLink />{cardsAvailable && cards.length > 0 ? "Pagar com novo cartão" : "Pagar"}
                    </button>
                </div>
            }
            {loading && <Loading fullPage={true} initialLoad={true} />}
            {processing && <Loading fullPage={true} />}
        </div>
    )
}

export default PaymentView
